import {updateLabelConfig} from '../../../data/labelInfos/index.js'
import ConfigCheckbox from './ConfigCheckbox.js'
import {
  FEDEX,
  FEDEX_360,
  SHIPPO,
} from '../../../common/constants/ShipperNames.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {
  defaultValidLabelPropertiesFunc,
  ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
} from './useLabelProperty.js'

const LABEL_PROPERTY = 'saturday_delivery'
const VALID_SHIPPER_TYPES = [FEDEX, FEDEX_360, SHIPPO]

export default function SaturdayDelivery() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = SaturdayDelivery.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  const label = [FEDEX, SHIPPO].includes(shipperType)
    ? 'Saturday Delivery Only'
    : 'Saturday Delivery'

  return (
    <ConfigCheckbox
      label={label}
      onChange={(checked) => {
        updateLabelConfig(labelInfoID, {[labelProperty]: checked})

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
    />
  )
}

SaturdayDelivery.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc() {
      return [LABEL_PROPERTY]
    },
    dependentPropertiesFunc: ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
